import 'whatwg-fetch'; 
import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
//将getRequest注册为vue的组件 封装axios 
import {getRequest} from "@/api/api";
Vue.prototype.getRequest = getRequest;
//引入swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
//引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//引入vueI18处理语言切换
import VueI18n from 'vue-i18n';
//引入element处理语言
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import CN from "@/languages/Chinese"
import EN from "@/languages/English"
//导入百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use( BaiduMap, { ak : 'lPGT5SsO8WZeFqAvmMtrPRfoRAM7I9r7' } )
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueI18n)
// 引入echarts图表。
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts; // 将echarts引入与到vue的原型中，方便使用
import china from '@/assets/js/china.json'
echarts.registerMap('china', china)
// 引入苹果浏览器适配问题
Vue.config.debug = true;
const i18n=new VueI18n({
  locale:localStorage.getItem("wms-local")||"zh",
  messages:{
    zh:{
      ...zhLocale,//elementui中文包
      ...CN
    },
    en:{
      ...enLocale,//elementui英文包
      ...EN
    }
  },
  silentTranslationWarn: true
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

Vue.config.productionTip = false
new Vue({
  router,
  i18n,
  render: h => h(App)
  
}).$mount('#app')
